export default{
	// 正式分支
	// baseUrl : 'https://appdouble.manmanxinli.com/',
	// 测试分支
	baseUrl : 'https://apple.08077801.xyz/',// api地址
}